import { Component, Input } from '@angular/core';

@Component({
  selector: 'hash-compare-display',
  templateUrl: './hash-compare-display.component.html',
  styleUrls: ['./hash-compare-display.component.scss']
})
export class HashCompareDisplayComponent {
  @Input() currentHash: string | null = null;
  @Input() lastHash: string | null = null;
  @Input() promotedAt: string | null = null;

  get processedCurrentHash(): string | null {
    return this.currentHash ? this.currentHash.replace(/^prod\//, '') : null;
  }

  get processedLastHash(): string | null {
    return this.lastHash ? this.lastHash.replace(/^prod\//, '') : null;
  }

  get isEqual(): boolean {
    return !!this.processedCurrentHash && !!this.processedLastHash && this.processedCurrentHash === this.processedLastHash;
  }
} 